import { IStoreState } from 'state/rootReducer';

export const patientSelector = (state: IStoreState) =>
  state.records.root.patient;

export const prescriptionSelector = (state: IStoreState) =>
  state.records.prescription;
